import { useState, useEffect, useCallback } from "react";
import axios from "axios";
import moment from "moment";
import getMandatoryEnv from "../../../../../sites-common/utils/getMandatoryEnv";

const useCommonData = () => {
  const { kmcFormConfig } = getMandatoryEnv(["kmcFormConfig"]);
  const [bannerData, setBannerDate] = useState([]);
  const [bannerRes, setBannerRes] = useState();
  const dateFormat = "DD/MM/YYYY";
  const [specialvisits, setSpecialvisits] = useState([]);
  const [loading, setLoading] = useState(false);
  const [getothers, setGetothers] = useState([]);
  const bannerGetData = useCallback(() => {
    axios.get(`${kmcFormConfig.formUrl}/api/kmc/getbanner`).then((res) => {
      setBannerDate(res?.data?.data);
      setBannerRes(res?.data);
      setLoading(true);
    });
  }, [kmcFormConfig.formUrl]);

  const checkspecialvisits = (specialvisitsData, methodName) => {
    const carosuel = specialvisitsData.filter((item) => {
      if (
        moment(item?.valid_to, dateFormat).format() >=
        moment(new Date(), dateFormat).startOf("day").format()
      ) {
        return item;
      }
      return null;
    });
    if (methodName === "specialVisits") setSpecialvisits(carosuel);
    if (methodName === "getOthers") setGetothers(carosuel);
  };
  const baseURL = `${kmcFormConfig.formUrl}/api/kmc/getspecialvisits`;
  const ImpAn = `${kmcFormConfig.formUrl}/api/kmc/getothers`;
  useEffect(() => {
    bannerGetData();
    const getspecialvisits = (baseURLData) => {
      axios.get(baseURLData).then((response) => {
        const sd = response.data.data.filter((i) => {
          return i.valid_from !== "" && i.valid_to !== "" && i.name !== "";
        });
        checkspecialvisits(sd, "specialVisits");
      });
    };
    getspecialvisits(baseURL);
    const getImportantAn = (ImpAnData) => {
      axios.get(ImpAnData).then((response) => {
        checkspecialvisits(response.data.data, "getOthers");
      });
    };
    getImportantAn(ImpAn);
  }, [ImpAn, bannerGetData, baseURL]);
  const checkBothExpired = () => {
    return specialvisits?.length > 0 || getothers?.length > 0;
  };
  const imp = getothers?.map((i) => {
    return { item: i.type };
  });
  const imp1 = imp.map((item) => {
    return item.item === "kmc_open_close_status" ? "true" : "else";
  });
  return {
    bannerData,
    bannerRes,
    loading,
    specialvisits,
    getothers,
    checkBothExpired,
    imp1,
    dateFormat,
  };
};

export default useCommonData;
